import React from "react";
import Socials from "./Socials";

import { NavHashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";

function Footer(props) {
    return (
        <footer
            id="footer"
            className="h-fit w-full flex flex-col bg-peachDarkPink text-peachBlack py-2"
        >
            <div className="flex flex-col  md:flex-row md:px-4 ">
                <div className="container-center flex flex-col flex-1 mt-3 md:mt-0 hidden">
                    <div className="text-2xl font-semibold tracking-tight mb-2  mt-0">
                        MISSION STATEMENT
                    </div>
                    <div className="text-base">
                        At Peaches, smooth skin has no boundaries! We’re all
                        about making everyone feel fabulous, confident, and
                        cared for. Our studio is your inclusive destination for
                        top-notch waxing, good vibes, and a big dose of
                        self-love. Because everyone deserves to glow their own
                        way!
                    </div>
                </div>
                <div className="container-right flex-1 flex flex-col justify-center mt-0 md:mt-0 ">
                    <div className="container-inner-footer-right flex flex-col justify-center">
                        <div className="flex flex-col md:flex-row justify-center">
                            <div className="flex flex-row justify-around md:justify-start">
                                <NavHashLink
                                    smooth
                                    to="/"
                                    className="block p-2 pl-0 text-peachBlack font-semibold"
                                >
                                    Home
                                </NavHashLink>
                                <NavHashLink
                                    smooth
                                    to="/about"
                                    className="block p-2 pl-0 text-peachBlack font-semibold"
                                >
                                    About
                                </NavHashLink>

                                <NavHashLink
                                    smooth
                                    to="/faq"
                                    className="block p-2 text-peachBlack font-semibold"
                                >
                                    FAQ
                                </NavHashLink>
                            </div>
                            <div className="flex flex-row justify-around md:justify-start">
                                <NavHashLink
                                    to="/contact"
                                    className="block p-2 text-peachBlack font-semibold"
                                >
                                    Contact us
                                </NavHashLink>
                                <NavHashLink
                                    smooth
                                    to="/terms#terms"
                                    className="block p-2 text-peachBlack font-semibold"
                                >
                                    Terms of use
                                </NavHashLink>
                                <NavHashLink
                                    smooth
                                    to="https://www.google.com/search?q=peaches+corpus+christi&sca_esv=baa52ac9cd6c629f&source=hp&ei=7OJ5Z6L7IK-7p84PhJu7qQU&iflsig=AL9hbdgAAAAAZ3nw_Hk0DSLTngfUS6AMmKBXpidvQ2MI&gs_ssp=eJzj4tVP1zc0LCsuia-wTDEzYLRSNaiwMDOzME1LTkw0S0tNNjdPszKoMEk2tDQxMU9LM0u0NEgxN_ISK0hNTM5ILVZIzi8qKAVSGUWZxSWZAI2YGHg&oq=peaches+corpus+chri&gs_lp=Egdnd3Mtd2l6IhNwZWFjaGVzIGNvcnB1cyBjaHJpKgIIADIOEC4YgAQYxwEYjgUYrwEyBhAAGBYYHjIGEAAYFhgeMgsQABiABBiGAxiKBTILEAAYgAQYhgMYigUyBRAAGO8FMgUQABjvBTIIEAAYogQYiQUyBRAAGO8FMggQABiiBBiJBUi8N1AAWPwpcAd4AJABAJgBXqAB3g2qAQIyNLgBAcgBAPgBAZgCH6ACuA7CAg4QLhiABBixAxjRAxjHAcICCxAAGIAEGLEDGIMBwgILEC4YgAQYsQMYgwHCAgUQABiABMICCxAuGIAEGNEDGMcBwgIREC4YgAQYsQMY0QMYgwEYxwHCAggQLhiABBixA8ICCBAAGIAEGLEDwgILEC4YgAQYxwEYrwHCAgsQLhiABBixAxjUAsICCBAuGIAEGOUEwgILEAAYgAQYsQMYigXCAgUQLhiABMICBxAAGIAEGArCAggQABgWGAoYHsICBRAhGKABwgIFECEYqwLCAgUQIRifBcICDhAuGNEDGBYYxwEYChgewgIIEAAYgAQYogSYAwCSBwIzMaAH84oC&sclient=gws-wiz#lrd=0x86685fcaa6fec77f:0x4c19447ff6a90d72,1,,,,"
                                    className="block p-2 text-peachBlack font-semibold"
                                >
                                    Send a love note
                                </NavHashLink>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex justify-center gap-3 my-1">
                <Link to="https://www.facebook.com/shoppeachescc/">
                    <svg
                        fill="#4c4343"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="25"
                        height="25"
                        viewBox="0 0 30 30"
                    >
                        <path d="M24,4H6C4.895,4,4,4.895,4,6v18c0,1.105,0.895,2,2,2h10v-9h-3v-3h3v-1.611C16,9.339,17.486,8,20.021,8 c1.214,0,1.856,0.09,2.16,0.131V11h-1.729C19.376,11,19,11.568,19,12.718V14h3.154l-0.428,3H19v9h5c1.105,0,2-0.895,2-2V6 C26,4.895,25.104,4,24,4z"></path>
                    </svg>
                </Link>

                <Link to="https://www.instagram.com/peaches.cc?igsh=MW9ndjdkcHcwcW80aA%3D%3D&utm_source=qr">
                    <svg
                        fill="#4c4343"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="25"
                        height="25"
                        viewBox="0 0 30 30"
                    >
                        <path d="M 9.9980469 3 C 6.1390469 3 3 6.1419531 3 10.001953 L 3 20.001953 C 3 23.860953 6.1419531 27 10.001953 27 L 20.001953 27 C 23.860953 27 27 23.858047 27 19.998047 L 27 9.9980469 C 27 6.1390469 23.858047 3 19.998047 3 L 9.9980469 3 z M 22 7 C 22.552 7 23 7.448 23 8 C 23 8.552 22.552 9 22 9 C 21.448 9 21 8.552 21 8 C 21 7.448 21.448 7 22 7 z M 15 9 C 18.309 9 21 11.691 21 15 C 21 18.309 18.309 21 15 21 C 11.691 21 9 18.309 9 15 C 9 11.691 11.691 9 15 9 z M 15 11 A 4 4 0 0 0 11 15 A 4 4 0 0 0 15 19 A 4 4 0 0 0 19 15 A 4 4 0 0 0 15 11 z"></path>
                    </svg>
                </Link>

                <Link to="https://www.tiktok.com/@peaches.cc?_t=8k8SJ4squU6&_r=1">
                    <svg
                        fill="#4c4343"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="25"
                        height="25"
                        viewBox="0 0 30 30"
                    >
                        <path d="M24,4H6C4.895,4,4,4.895,4,6v18c0,1.105,0.895,2,2,2h18c1.105,0,2-0.895,2-2V6C26,4.895,25.104,4,24,4z M22.689,13.474 c-0.13,0.012-0.261,0.02-0.393,0.02c-1.495,0-2.809-0.768-3.574-1.931c0,3.049,0,6.519,0,6.577c0,2.685-2.177,4.861-4.861,4.861 C11.177,23,9,20.823,9,18.139c0-2.685,2.177-4.861,4.861-4.861c0.102,0,0.201,0.009,0.3,0.015v2.396c-0.1-0.012-0.197-0.03-0.3-0.03 c-1.37,0-2.481,1.111-2.481,2.481s1.11,2.481,2.481,2.481c1.371,0,2.581-1.08,2.581-2.45c0-0.055,0.024-11.17,0.024-11.17h2.289 c0.215,2.047,1.868,3.663,3.934,3.811V13.474z"></path>
                    </svg>
                </Link>
            </div>
            <div className="flex flex-col md:flex-row justify-between md:justify-center md:gap-5">
                <Link
                    to="https://www.google.com/maps/place/525+Everhart+Rd,+Corpus+Christi,+TX+78411/@27.7307859,-97.3739593,16z/data=!3m1!4b1!4m6!3m5!1s0x86685f607abab201:0x849f3d1e18f30cd7!8m2!3d27.7307859!4d-97.3739593!16s%2Fg%2F11c5plwdhb?entry=ttu&g_ep=EgoyMDI1MDEwMS4wIKXMDSoASAFQAw%3D%3D"
                    className="text-center text-peachBlack mt-3 md:mt-0"
                >
                    525 Everhart Rd Suite 2, Corpus Christi, TX 78411
                </Link>
                <div className=" text-center pb-2 mt-3 md:mt-0">
                    {" "}
                    <span>&#169; {new Date().getFullYear()} </span>Peaches
                </div>
            </div>
        </footer>
    );
}

export default Footer;
